/* Dirt Vision theme v2.1. Plain JS, no dependencies. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};

  function t(key, fallback) { return strings[key] || fallback; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function readJSON(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function postJSON(path, body) {
    return fetch(path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong');
        return data;
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var menu = $('[data-mobile-menu]');
    var openBtn = $('[data-menu-open]');
    if (!menu || !openBtn) return;
    function setOpen(open) {
      menu.hidden = !open;
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      lock(open);
    }
    openBtn.addEventListener('click', function () { setOpen(true); });
    $$('[data-menu-close]', menu).forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) setOpen(false); });
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var btn = $('[data-scroll-top]');
    if (!btn) return;
    function onScroll() { btn.classList.toggle('is-visible', window.scrollY > 600); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Shipping timeline dates ---------- */
  function initTimelines() {
    $$('[data-timeline]').forEach(function (el) {
      function num(attr) { return Number(el.getAttribute(attr)) || 0; }
      function addBusinessDays(from, days) {
        var d = new Date(from.getTime());
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          var day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      }
      function fmt(d) {
        try { return d.toLocaleDateString(theme.locale || undefined, { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); }
      }
      function set(sel, text) { var x = $(sel, el); if (x) x.textContent = text; }
      var today = new Date();
      var pMin = num('data-proc-min'), pMax = num('data-proc-max'), dMin = num('data-del-min'), dMax = num('data-del-max');
      set('[data-timeline-today]', fmt(today));
      set('[data-timeline-ships]', fmt(addBusinessDays(today, pMin)) + ' - ' + fmt(addBusinessDays(today, Math.max(pMin, pMax))));
      set('[data-timeline-delivered]', fmt(addBusinessDays(today, pMin + dMin)) + ' - ' + fmt(addBusinessDays(today, Math.max(pMin + dMin, pMax + dMax))));
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gallery = $('[data-gallery]', root);
    if (!gallery) return null;
    var slides = $$('[data-slide]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    var index = 0;
    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (th, n) {
        th.classList.toggle('is-active', n === index);
        if (n === index && th.parentNode.scrollTo) th.parentNode.scrollTo({ left: th.offsetLeft - 16, behavior: 'smooth' });
      });
    }
    thumbs.forEach(function (th) { th.addEventListener('click', function () { go(Number(th.getAttribute('data-thumb'))); }); });
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    var main = $('.gallery__main', gallery);
    var startX = null;
    if (main && slides.length > 1) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }
    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        slides.forEach(function (s, n) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) go(n); });
      }
    };
  }

  /* ---------- Product: option buttons, dropdowns, price, sticky bar, add to cart ---------- */
  function initProduct(root) {
    var product = readJSON($('[data-product-json]', root));
    if (!product) return;
    var tiers = readJSON($('[data-tiers-json]', root)) || [];
    var gallery = initGallery(root);
    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-to-cart]', form) : null;
    var addLabel = form ? $('[data-add-label]', form) : null;
    var errorEl = form ? $('[data-product-error]', form) : null;
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var saveEl = $('[data-save]', root);
    var savePctEl = $('[data-save-pct]', root);
    var pickers = $$('[data-picker]', root);
    var dealNote = $('[data-deal-note]', root);
    var sticky = $('[data-sticky-atc]', root);
    var stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null;
    var stickyBuy = sticky ? $('[data-sticky-buy]', sticky) : null;
    var variants = product.variants || [];
    // Liquid already rendered a correct, buyable button. If this copy of the product JSON carries no
    // variants (seen on the homepage's featured-product block), leave that button alone rather than
    // overwriting it with "Unavailable".
    if (!variants.length) return;

    var initialId = idInput ? Number(idInput.value) : null;
    var current = variants.filter(function (v) { return v.id === initialId; })[0] || firstSellable();
    var selected = current ? current.options.slice() : [];

    function firstSellable() {
      return variants.filter(function (v) { return v.available; })[0] || variants[0];
    }
    // Match on the options we actually have a pill/dropdown for. A product with an extra option in the
    // admin (or an option value the picker never set) must NOT dead-end the buy button.
    function findVariant(opts, changedIndex) {
      var matches = variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return opts[i] === undefined || opts[i] === null || o === opts[i];
        });
      });
      if (!matches.length && changedIndex !== undefined && opts[changedIndex] !== undefined) {
        // Fall back to any variant carrying the value the shopper just picked.
        matches = variants.filter(function (v) { return v.options[changedIndex] === opts[changedIndex]; });
      }
      if (!matches.length) return firstSellable();
      return matches.filter(function (v) { return v.available; })[0] || matches[0];
    }
    function tierFor(value) {
      var key = String(value || '').toLowerCase().trim();
      return tiers.filter(function (tr) { return tr.value && tr.value.toLowerCase().trim() === key; })[0];
    }
    function activeTier() {
      for (var i = 0; i < selected.length; i++) {
        var tr = tierFor(selected[i]);
        if (tr) return tr;
      }
      return {};
    }

    function render() {
      var available = !!(current && current.available);
      var hasCompare = !!(current && current.compare_at_price && current.compare_at_price > current.price);
      if (current && priceEl) priceEl.textContent = formatMoney(current.price);
      if (compareEl) {
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = formatMoney(current.compare_at_price);
      }
      if (saveEl) {
        saveEl.hidden = !hasCompare;
        if (hasCompare && savePctEl) savePctEl.textContent = Math.round((current.compare_at_price - current.price) * 100 / current.compare_at_price);
      }
      if (idInput) idInput.value = current ? current.id : '';
      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel) {
          addLabel.textContent = available ? t('add_to_cart', 'Add to cart') + ' · ' + formatMoney(current.price)
            : current ? t('sold_out', 'Sold out')
            : t('unavailable', 'Unavailable');
        }
      }
      if (stickyPrice && current) stickyPrice.textContent = formatMoney(current.price);
      if (stickyBuy) stickyBuy.disabled = !available;
      pickers.forEach(function (p) {
        var i = Number(p.getAttribute('data-option-index'));
        var value = selected[i];
        var label = $('[data-picker-value]', p);
        if (label) label.textContent = value;
        $$('.pill', p).forEach(function (b) {
          var on = b.getAttribute('data-value') === value;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var sel = $('[data-option-select]', p);
        if (sel) sel.value = value;
      });
      if (dealNote) {
        var tier = activeTier();
        var parts = [tier.label, tier.gift].filter(function (x) { return x; });
        dealNote.textContent = parts.join(' · ');
        dealNote.hidden = parts.length === 0;
      }
    }

    function update(changedIndex) {
      current = findVariant(selected, changedIndex) || current;
      // Keep the pickers honest: show the options of the variant that is actually selected.
      if (current) selected = current.options.slice();
      if (current && gallery && current.featured_media) gallery.showMedia(current.featured_media.id);
      if (current && document.body.classList.contains('template-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }
      render();
    }

    pickers.forEach(function (p) {
      var i = Number(p.getAttribute('data-option-index'));
      p.addEventListener('click', function (e) {
        var pill = e.target.closest('.pill');
        if (!pill) return;
        selected[i] = pill.getAttribute('data-value');
        update(i);
      });
      p.addEventListener('change', function (e) {
        if (!e.target.hasAttribute('data-option-select')) return;
        selected[i] = e.target.value;
        update(i);
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !current) return;
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var tier = activeTier();
        var item = { id: current.id, quantity: 1 };
        if (tier.gift) item.properties = { 'Free gift': tier.gift };
        if (addBtn) addBtn.classList.add('is-loading');
        postJSON((theme.routes && theme.routes.cartAdd || '/cart/add') + '.js', { items: [item] })
          .then(function () {
            if (addBtn) addBtn.classList.remove('is-loading');
            if (window.dvCart) window.dvCart.open(); else window.location.href = (theme.routes && theme.routes.cart) || '/cart';
          })
          .catch(function (err) {
            if (addBtn) addBtn.classList.remove('is-loading');
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          });
      });
    }

    if (sticky && form && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBuy) stickyBuy.tabIndex = show ? 0 : -1;
      });
      observer.observe(form);
      if (stickyBuy) {
        stickyBuy.addEventListener('click', function () {
          if (addBtn && addBtn.disabled) return;
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    }

    render();
  }

  /* ---------- Cart drawer ---------- */
  function initCart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    var lines = $('[data-cart-lines]', drawer);
    var empty = $('[data-cart-empty]', drawer);
    var countEl = $('[data-cart-drawer-count]', drawer);
    var unitEl = $('[data-cart-drawer-unit]', drawer);
    var subtotalEl = $('[data-cart-subtotal]', drawer);
    var errorEl = $('[data-cart-error]', drawer);
    var timerEl = $('[data-cart-timer]', drawer);
    var routes = theme.routes || {};
    var cartRoot = routes.cart || '/cart';
    var timer = null;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }
    function updateBadges(count) {
      $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    }

    function render(cart) {
      var html = '';
      cart.items.forEach(function (item, i) {
        var line = i + 1;
        var props = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (k) {
            var val = item.properties[k];
            if (k.charAt(0) === '_' || val === '' || val == null) return;
            props += '<p class="cart-line__prop">' + escapeHtml(k) + ': ' + escapeHtml(val) + '</p>';
          });
        }
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
        var img = item.image ? '<img class="cart-line__image" src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span class="cart-line__image"></span>';
        var compare = item.original_line_price > item.final_line_price ? '<s class="cart-line__compare">' + formatMoney(item.original_line_price) + '</s>' : '';
        html += '<li class="cart-line">' + img + '<div class="cart-line__info"><p class="cart-line__title">' + escapeHtml(item.product_title) + '</p>' + variant + props +
          '<div><span class="cart-line__qty"><button type="button" data-qty="' + line + '" data-to="' + (item.quantity - 1) + '" aria-label="-">&minus;</button><span>' + item.quantity + '</span><button type="button" data-qty="' + line + '" data-to="' + (item.quantity + 1) + '" aria-label="+">+</button></span>' +
          '<button type="button" class="cart-line__remove" data-qty="' + line + '" data-to="0">' + escapeHtml(t('remove', 'Remove')) + '</button></div></div>' +
          '<div class="cart-line__prices"><span class="cart-line__price">' + (item.final_line_price === 0 ? escapeHtml(t('free', 'FREE')) : formatMoney(item.final_line_price)) + '</span>' + compare + '</div></li>';
      });
      lines.innerHTML = html;
      if (empty) empty.hidden = cart.items.length > 0;
      if (countEl) countEl.textContent = cart.item_count;
      if (unitEl) unitEl.textContent = cart.item_count === 1 ? t('item', 'item') : t('items', 'items');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      updateBadges(cart.item_count);
    }

    function refresh() { return postJSON(cartRoot + '.js').then(render); }

    function changeLine(line, quantity) {
      drawer.classList.add('is-loading');
      showError('');
      return postJSON((routes.cartChange || '/cart/change') + '.js', { line: line, quantity: Math.max(0, quantity) })
        .then(render)
        .catch(function (err) { showError(err.message); })
        .then(function () { drawer.classList.remove('is-loading'); });
    }

    function startTimer() {
      if (!timerEl || !theme.cartReserveEnabled) return;
      var left = Number(theme.cartReserveSeconds) || 300;
      function draw() {
        var m = Math.floor(left / 60), s = left % 60;
        timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      }
      clearInterval(timer);
      draw();
      timer = setInterval(function () { left = Math.max(0, left - 1); draw(); if (!left) clearInterval(timer); }, 1000);
    }

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lock(true);
      startTimer();
      refresh().catch(function (err) { showError(err.message); });
      var closeBtn = $('.cart-drawer__header [data-cart-close]', drawer);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      clearInterval(timer);
      lock(false);
    }

    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $$('[data-cart-close]', drawer).forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    lines.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      changeLine(Number(btn.getAttribute('data-qty')), Number(btn.getAttribute('data-to')));
    });

    window.dvCart = { open: open, close: close, refresh: refresh };
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initScrollTop();
    initTimelines();
    initCart();
    $$('[data-product-page]').forEach(initProduct);
  });
})();
